'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { funnelSchema } from '~/lib/schemas/funnel-schema'
import { useFunnelStore } from '../../_hooks/use-funnel-store'
import type { FunnelStepComponent } from '../../types'
import { FunnelStep } from '../FunnelStep'

const schema = funnelSchema.pick({ household_income: true })

export const HouseholdIncome: FunnelStepComponent = ({ onSubmit }) => {
  const householdIncome = useFunnelStore.getState().data.household_income as number | undefined
  const { control, formState, handleSubmit } = useForm({
    resolver: zodResolver(schema),
    defaultValues: { household_income: householdIncome },
    mode: 'onChange',
  })

  return (
    <FunnelStep onSubmit={handleSubmit(onSubmit)}>
      <FunnelStep.Title>Estimate your household&rsquo;s annual pre-tax income</FunnelStep.Title>
      <FunnelStep.CurrencyInput name="household_income" placeholder="$ Annual Income" control={control} autoFocus />
      <FunnelStep.Button disabled={!formState.isValid}>Next</FunnelStep.Button>
    </FunnelStep>
  )
}

HouseholdIncome.path = 'household-income'
HouseholdIncome.schema = schema
HouseholdIncome.pageActionSteps = ['household_income']
